var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.525 14.2247C17.3417 14.3747 17.1333 14.4539 16.9 14.4622C16.6667 14.4706 16.4667 14.3914 16.3 14.2247L11.975 9.89973L7.62501 14.2497C7.47501 14.3997 7.27084 14.4706 7.01251 14.4622C6.75417 14.4539 6.55001 14.3747 6.40001 14.2247C6.21667 14.0414 6.12917 13.8372 6.13751 13.6122C6.14584 13.3872 6.23334 13.1914 6.40001 13.0247L11.375 8.04973C11.475 7.9664 11.5708 7.9039 11.6625 7.86223C11.7542 7.82057 11.8583 7.79973 11.975 7.79973C12.0917 7.79973 12.1958 7.82057 12.2875 7.86223C12.3792 7.9039 12.475 7.9664 12.575 8.04973L17.525 12.9997C17.6917 13.1664 17.7708 13.3664 17.7625 13.5997C17.7542 13.8331 17.675 14.0414 17.525 14.2247Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.525 14.2247C17.3417 14.3747 17.1333 14.4539 16.9 14.4622C16.6667 14.4706 16.4667 14.3914 16.3 14.2247L11.975 9.89973L7.62501 14.2497C7.47501 14.3997 7.27084 14.4706 7.01251 14.4622C6.75417 14.4539 6.55001 14.3747 6.40001 14.2247C6.21667 14.0414 6.12917 13.8372 6.13751 13.6122C6.14584 13.3872 6.23334 13.1914 6.40001 13.0247L11.375 8.04973C11.475 7.9664 11.5708 7.9039 11.6625 7.86223C11.7542 7.82057 11.8583 7.79973 11.975 7.79973C12.0917 7.79973 12.1958 7.82057 12.2875 7.86223C12.3792 7.9039 12.475 7.9664 12.575 8.04973L17.525 12.9997C17.6917 13.1664 17.7708 13.3664 17.7625 13.5997C17.7542 13.8331 17.675 14.0414 17.525 14.2247Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.3c9b7131.svg";
export { ForwardRef as ReactComponent };